import { useState } from 'react';
import { useParams } from 'react-router-dom';
import { Copy, Check } from 'lucide-react';
import CreateCardLinkForm from './CreateCardLinkForm';

import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription
} from '@/components/ui/dialog';
import { Textarea } from '@/components/ui/textarea';
import Loader from '@/components/common/Loader';
import { Button } from '@/components/ui/button';

import { useUserCard } from '@/data/card';

const GenerateCardLinkDialog = ({ onClose }) => {
  const params = useParams();
  const userCard = useUserCard(params.id);
  const [copied, setCopied] = useState(false);

  const handleCreateCardSuccess = (newCard) => {
    userCard.mutate(newCard, false);
  };

  if (userCard.isLoading && !userCard.data) {
    return (
      <Dialog open onOpenChange={onClose}>
        <DialogContent>
          <div className="flex justify-center items-center h-48">
            <Loader />
          </div>
        </DialogContent>
      </Dialog>
    );
  }

  if (!userCard.data) {
    return (
      <Dialog open onOpenChange={onClose}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>Generate New Card Link</DialogTitle>
            <DialogDescription>
              This action will generate a new card link for the user. Take this
              link and program the NFC card with it.
            </DialogDescription>
          </DialogHeader>
          <CreateCardLinkForm
            userId={params.id}
            onSuccess={handleCreateCardSuccess}
          />
        </DialogContent>
      </Dialog>
    );
  }

  return (
    <Dialog open onOpenChange={onClose}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Card Link</DialogTitle>
          <DialogDescription>
            This is the users card link. Any user who visits this link will be
            redirected to where the user has set their card mode to.
          </DialogDescription>
        </DialogHeader>
        <Textarea
          value={userCard.data.cardLink}
          readOnly
          className="w-full h-12 font-mono text-sm break-all border border-gray-300 rounded p-2"
          placeholder="Generated link will appear here..."
        />
        <Button
          onClick={() => {
            navigator.clipboard.writeText(userCard.data.cardLink);
            setCopied(true);
          }}
          variant={copied ? 'outline' : ''}
        >
          {copied ? (
            <>
              <Check className="w-4 h-4 mr-2" />
              Copied
            </>
          ) : (
            <>
              <Copy className="w-4 h-4 mr-2" />
              Copy
            </>
          )}
        </Button>
      </DialogContent>
    </Dialog>
  );
};

export default GenerateCardLinkDialog;
